<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapterv">Contents</h1>
<p class="nonindent"><a href="#/text/9780062378576_B1_Cover">My Booky Wook</a></p>
<p class="nonindent"><span href="#/text/9780062378576_B2_Cover" title="Link target outside of Sample">Booky Wook 2</span></p>
<p class="nonindent" id="ataa" style="margin-top:1em;"><span href="#/text/About_the_Author#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="nonindent" id="atp_01"><span href="#/text/About_the_Publisher#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062378576_Contents.vue?40009026